const isSearchActive = (state = false, {type, isSearchActive}) => {
  switch (type) {
    case 'TOGGLE_SEARCH':
      return isSearchActive
  }
  return state
}

export default isSearchActive
